// extracted by mini-css-extract-plugin
export default {"container":"main_container__tz0Ev","slider":"main_slider__JuH+X","booksSliderContainer":"main_booksSliderContainer__p+GvJ"};